export function deepEqual(a, b) {
  if (Array?.isArray(a) && Array?.isArray(b)) {
    return a?.length === b?.length && a?.every((v, i) => deepEqual(v, b[i]));
  }
  if (typeof a === "object" && typeof b === "object" && a && b) {
    const keysA = Object?.keys(a);
    const keysB = Object?.keys(b);
    if (keysA?.length !== keysB?.length) return false;
    return keysA?.every((key) => deepEqual(a[key], b[key]));
  }
  return a === b;
}

export function compareEmrItems(oldItems = [], newItems = []) {
  let updatedItems = false;
  const compared = [];

  newItems.forEach((newItem) => {
    const oldItem = oldItems?.find((o) => o?.item_id === newItem?.item_id);

    if (!oldItem) {
      updatedItems = true;
      compared.push({
        ...newItem,
        is_new: true,
        is_deleted: false,
        is_updated: false,
      });
    } else {
      const isChanged = !deepEqual(newItem, oldItem);

      if (isChanged) {
        updatedItems = true;
        compared.push({
          ...newItem,
          is_new: false,
          is_deleted: false,
          is_updated: true,
        });
      } else {
        compared.push({
          ...newItem,
          is_new: false,
          is_deleted: false,
          is_updated: false,
        });
      }
    }
  });

  oldItems?.forEach((oldItem) => {
    if (!newItems?.some((n) => n?.item_id === oldItem?.item_id)) {
      updatedItems = true;
      compared.push({
        ...oldItem,
        is_new: false,
        is_deleted: true,
        is_updated: false,
      });
    }
  });

  return { updated_items: updatedItems, items: compared };
}

export function levenshtein(a, b) {
  const matrix = [];

  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }

  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }

  return matrix[b.length][a.length];
}
